import { styled } from '@mui/material/styles';
import Paper, { PaperProps } from '@mui/material/Paper';

const RoundedPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  borderRadius: 12,
  padding: 20,
  border: `1px solid ${theme.palette.divider}`,
}));

export default RoundedPaper;
